import styled from 'styled-components';
import Button from '#/shared/components/Buttons';

/** TODO: Update EditButton to use the Button component.
 * https://trimet.atlassian.net/browse/PUBWEB-1790
 */

export const EditButton = styled.button`
  display: flex;
  flex: 0;
  border-radius: ${({ theme }) => theme.buttonRadius};
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  color: ${({ theme }) => theme.dropDownText};
  background-color: ${({ theme }) => theme.dropDownEditBg};
  border: 1px solid ${({ theme }) => theme.dropDownBorder};
  font-size: 1rem;
  /* ensure hover styling is not sticky on mobile,
  checking the pointer as a workaround for Samsung:
  https://stackoverflow.com/a/28058919/2167004,
  https://www.ctrl.blog/entry/css-media-hover-samsung.html */
  @media (any-hover: hover) and (pointer: fine) {
    &:hover {
      background-color: ${({ theme }) => theme.dropDownEditBgHover};
      cursor: pointer;
    }
  }
`;

export const EditIconWrapper = styled.div`
  fill: ${({ theme }) => theme.dropDownText};
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 0.7em;
`;

export const CloseButton = styled(Button)`
  color: ${({ theme }) => theme.dropDownText};
  font-size: 0.6em;
  margin-bottom: 10px;
  padding: 5px 0;
  width: 60%;

  /* Safari only styling: https://stackoverflow.com/a/25975282/2167004. Safari
  doesn't support border-radius for outlines as of v16 so swap the outline for a
  border; outline is preferable for other browsers because it doesn't change the
  size of the button which creates a smoother appearance when tabbing */
  @media not all and (min-resolution: 0.001dpcm) {
    @media {
      outline: none;
      border: 1px solid;
    }
  }
`;
